import PropTypes from 'prop-types';
import React from 'react';

import styles from './loader.scss';

const propTypes = {
  loading: PropTypes.bool,
};

const Loader = ({ loading }) => (
  loading
    ? (
      <div className={styles.container}>
        <div className={styles.loader}>
          <div />
          <div />
          <div />
        </div>
      </div>
    )
    : null
);

Loader.propTypes = propTypes;

export default Loader;
